import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function LoadingOverlay(props) {
  const {
    active = false,
    spinner = false,
    text,
    children
  } = props;

  // When not active, behave like the old library: render children normally.
  if (!active) return children ?? null;

  return (
    <>
      {children}
      <Backdrop
        open
        sx={(theme) => ({
          zIndex: theme.zIndex.modal + 1
        })}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            px: 2
          }}
        >
          {spinner ? <CircularProgress color="inherit" /> : null}
          {text ? (
            <Typography variant="body2" sx={{ userSelect: 'none', textAlign: 'center' }}>
              {text}
            </Typography>
          ) : null}
        </Box>
      </Backdrop>
    </>
  );
}
